import React from 'react';

const ModalCloseButton = ({ onClick, className = '', label = 'Close' }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    className={`inline-flex h-10 w-10 sm:w-auto items-center justify-center sm:gap-2 rounded-full border border-gray-200 bg-white sm:px-4 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-primary/15 ${className}`}
  >
    <span aria-hidden="true" className="text-xl sm:text-lg leading-none text-gray-500">×</span>
    <span className="hidden sm:inline">{label}</span>
  </button>
);

export default ModalCloseButton;
